import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotModal from './ForgotModal';
import language from '../../../assets/languages/language';
import FD from '../../RestAPI/fetchData';
// import GD from '../../RestAPI/getData';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';
import cookie from 'react-cookies';
// import { getDeviceDetails } from '../../../common/deviceDetails';
import { getIpAddress } from '../../../common/getIpAddress';
import { examRedirectRoute } from '../../Common/examRedirectRoute';
import userStore from '../../../store/userStore';
// import { showFailure } from '../../../common/toast';
// import Header from '../../../components/Header/Header';
// const queryString = require("query-string");

/* eslint-disable*/

class Auth extends Component {
  constructor(props) {
    window.scroll(0, 0);
    // console.log("window.location.protocol ", window.location.protocol);
    // console.log("window.location.hostname ", window.location.hostname);

    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      forgotOpenStatus: false,
      qq_user_code: '',
      qq_user_nickname: '',
      qq_user_image_url: '',
      startLoaderPage: false,
      urlToRedirect: this.props.location.state ? this.props.location.state.urlToRedirect : null,
      userType: 'user',
      pageNotFound: false,
      landingSource: 'organic',
      landingSourceName: null,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
  }

  async componentDidMount() {
    try {

      try {
        const result1 = await getIpAddress();
        if (result1) {
          this.setState({
            user_city: result1.city || '',
            user_country: result1.country || '',
            user_ip: result1.query || '',
            user_state: result1.region || '',
            user_continent: result1.continent || '',
          });
        }
      } catch (err) {
        console.error('Error fetching IP address:', err);
      }

      const parsed = this.props.location.query || {};
      const landingSourceCookie = cookie.load('utm_source', {
        path: '/',
        domain: '.analystprep.com',
      });

      const landingSource = landingSourceCookie || 'organic';
      localStorage.setItem('landingSource', landingSource);

      this.setState({ landingSource });

      const tapfiliateRef = cookie.load('ref', {
        path: '/',
        domain: '.analystprep.com',
      });

      if (tapfiliateRef) {
        this.setState({
          landingSource: 'tapfiliate',
          landingSourceName: tapfiliateRef,
        });
        localStorage.setItem('landingSource', 'tapfiliate');
      }

      localStorage.setItem('landingSourceName', tapfiliateRef || '');

      const hostDomain = window.location.hostname;
      const parsedData = hostDomain.split('.') || [];

      const configDomain =
        App_data.frontend_url != null && App_data.frontend_url !== ''
          ? new URL(App_data.frontend_url)
          : { host: 'app.analystprep.com' };

      // Partner identity may arrive explicitly via a proxy-login query param
      // (used where the hostname cannot carry the partner subdomain, e.g. branch/dev
      // environments). Prefer it; otherwise fall back to hostname-based detection (live).
      const proxyOrganizationDomain = parsed.organizationDomain;

      if (proxyOrganizationDomain) {
        try {
          const resp = await FD.callAPI(`${App_data.backend_api}/auth/getDetailsByDomain`, {
            partnerDomain: proxyOrganizationDomain,
          });
          if (resp.success && resp.data) {
            localStorage.setItem('role', 'partner');
            localStorage.setItem('organizationDomain', resp.data.organizationDomain);
          } else {
            localStorage.removeItem('role');
            localStorage.removeItem('organizationDomain');
          }
        } catch (err) {
          console.error('Error fetching domain details:', err);
        }
      } else if (
        parsedData.length &&
        hostDomain !== configDomain.host &&
        parsedData[1] === 'analystprep'
      ) {
        try {
          const subDomain = parsedData[0];
          const data = { partnerDomain: subDomain };

          const resp = await FD.callAPI(`${App_data.backend_api}/auth/getDetailsByDomain`, data);
          if (resp.success && resp.data) {
            localStorage.setItem('role', 'partner');
            localStorage.setItem('organizationDomain', resp.data.organizationDomain);
          } else {
            this.setState({ pageNotFound: true });
            localStorage.removeItem('role');
            localStorage.removeItem('organizationDomain');
          }
        } catch (err) {
          console.error('Error fetching domain details:', err);
        }
      } else {
        // Not a partner context (main app domain, or a single-origin dev/localhost host).
        // Clear any stale partner flags so a previous partner login (e.g. proxy login on the
        // same origin) can't leak organizationDomain/role into a subsequent regular
        // social/password login and trigger the "wrong domain" rejection.
        localStorage.removeItem('role');
        localStorage.removeItem('organizationDomain');
      }

      const userData = {
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      localStorage.setItem('userData', JSON.stringify(userData));

      const proxyToken = parsed.proxyToken;
      
      if (proxyToken) {
        let proxyResponse = null;
        try {
          proxyResponse = await FD.callAPI(
            `${App_data.backend_api}/user/proxyLogin`,
            { proxyToken }
          );
          
          const token = proxyResponse.token || (proxyResponse.data && proxyResponse.data.token);
          const idname = proxyResponse.idname || (proxyResponse.data && proxyResponse.data.idname);
          
          if (!token || !idname) {
            throw new Error('Something went wrong. Please try again later.');
          }
          
          userStore.clear();
          
          userStore.setToken(token);
          
          try {
            await userStore.fetchProfile(idname);
          } catch (e) {
            console.warn('Error preloading profile after proxyLogin', e);
          }
          
          localStorage.removeItem('localstorageval');
          const localStorageArray = { token, idname };
          localStorage.setItem('localstorageval', JSON.stringify(localStorageArray));
          
          const selectedExam = parsed.exam;
          
          if (!selectedExam) {
            window.location.href = '/selectexam';
            // browserHistory.push({ // does not update user in header
            //   pathname: '/selectexam',
            //   state: { token, idname },
            // });
          } else if (examRedirectRoute[selectedExam]) {
            localStorage.setItem('selectedmenu', selectedExam);
            window.location.href = examRedirectRoute[selectedExam];
            // browserHistory.push({ // does not update user in header
            //   pathname: examRedirectRoute[selectedExam],
            //   state: { token, idname },
            // });
          }

        } catch (error) {
          console.error(error)
          alert(proxyResponse.message || error.message || 'Something went wrong. Please try again later.');
          localStorage.removeItem('localstorageval');
        }
      }

      if (this.props.location.state) {
        const { pageToOpen, urlToRedirect, forgotOpenStatus } = this.props.location.state;

        this.setState({
          activeTab: pageToOpen === '2' ? '2' : '1',
          urlToRedirect,
          forgotOpenStatus,
        });
      }
    } catch (error) {
      console.error('Unexpected error in Auth.js componentDidMount:', error);
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        forgotOpenStatus: false,
      });
    }
  }

  handleForgot = () => {
    this.setState({ forgotOpenStatus: !this.state.forgotOpenStatus });
  };

  toggleHandleForgot = (status) => {
    this.setState({ forgotOpenStatus: !status });
  };

  // socialQQLogin = (e) => {
  //   this.signinRef.socialLoginQQ(e)
  // }

  goToForum = (e) => {
    // console.log("goToForum");
    browserHistory.push({
      pathname: '/forum',
    });
  };
  render() {
    // console.log("************", this.state.landingSource);
    const { qq_user_code, qq_user_nickname, qq_user_image_url, pageNotFound } = this.state;
    // console.log('this.props.params', this.props);
    return (
      <div className='login-full-wraper'>
        {this.state.startLoaderPage ? (
          <div className='loader_box'>
            <div className='sk-circle'>
              <div className='sk-circle1 sk-child' />
              <div className='sk-circle2 sk-child' />
              <div className='sk-circle3 sk-child' />
              <div className='sk-circle4 sk-child' />
              <div className='sk-circle5 sk-child' />
              <div className='sk-circle6 sk-child' />
              <div className='sk-circle7 sk-child' />
              <div className='sk-circle8 sk-child' />
              <div className='sk-circle9 sk-child' />
              <div className='sk-circle10 sk-child' />
              <div className='sk-circle11 sk-child' />
              <div className='sk-circle12 sk-child' />
            </div>
          </div>
        ) : null}

        {pageNotFound ? (
          <div className='d-flex login-img-main-block align-items-center'>
            <section className='error-section'>
              <div className='container'>
                <div className='text-center'>
                  <div className='text-notfound'>404!</div>
                  <h1 className='score-text'>Sorry, The Page not found</h1>
                  <br />
                  <p>
                    We’re sorry, the domain you have looked for does not registered with our
                    AnalystPrep organisation!
                  </p>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className='login-main-wraper'>
            {/* <span
              className='login-form-forum-link-mobile'
              onClick={() => {
                this.goToForum();
              }}
            >
              {' '}
              <i className='fa fa-comments-o' aria-hidden='true' />
              Forum
            </span> */}
            <div className='d-flex login-img-main-block align-items-center'>
              <div className='login-main-block'>
                <h1 className='login-heading'>{language.LC().WELCOME_TO_ANALYSTPREP}</h1>
                <div className={'justify-content-center'}>
                  <div className='login-block'>
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={`${this.state.activeTab === '1' ? 'active' : ''}`}
                          onClick={() => {
                            this.toggle('1');
                          }}
                        >
                          {language.LC().SIGN_IN}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === '2',
                          })}
                          onClick={() => {
                            this.toggle('2');
                          }}
                        >
                          {language.LC().SIGN_UP}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId='1'>
                        <SignIn
                          qq_user_code={qq_user_code}
                          qq_user_nickname={qq_user_nickname}
                          qq_user_image_url={qq_user_image_url}
                          urlToRedirect={this.state.urlToRedirect}
                          {...this.props}
                        />
                      </TabPane>

                      <TabPane tabId='2'>
                        <SignUp
                          urlToRedirect={this.state.urlToRedirect}
                          landingSource={this.state.landingSource}
                          landingSourceName={this.state.landingSourceName}
                        />
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
                <ForgotModal
                  forgotOpen={this.state.forgotOpenStatus}
                  onToggle={this.toggleHandleForgot}
                />{' '}
                <blockquote className='footer-blockquote-login'>
                  <p>{language.LC().FOOTER_MESSAGE}</p>
                  <span className='ml-1'>
                    <a
                      href='https://analystprep.com/privacy/'
                      target='_blank'
                      className='privacy-policy'
                    >
                      {language.LC().Privacy_Policy}
                    </a>
                  </span>
                </blockquote>{' '}
              </div>
              <div className='login-image'>
                {/* <span
                  className='login-form-forum-link'
                  onClick={() => {
                    this.goToForum();
                  }}
                >
                  {' '}
                  <i className='fa fa-comments-o' aria-hidden='true' />
                  Forum
                </span> */}
              </div>
            </div>{' '}
          </div>
        )}
      </div>
    );
  }
}
export default Auth;



// WEBPACK FOOTER //
// ./src/views/Pages/Auth/Auth.js